/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge } from '@/shared/ui/badge';

interface StatusBarProps {
  mode: string;
  scale: number;
  photoIndexMode: boolean;
  selectedMarkers: Set<number>;
  savePhotoMarkersMutation: any;
  currentPolygon: any;
  isHorizontalConstrained: boolean;
  isVerticalConstrained: boolean;
}

const StatusBar = ({
  mode,
  scale,
  photoIndexMode,
  selectedMarkers,
  savePhotoMarkersMutation,
  currentPolygon,
  isHorizontalConstrained,
  isVerticalConstrained,
}: StatusBarProps) => {
  const modeLabel =
    mode === 'measure'
      ? 'Phases/Zones'
      : mode === 'areaTags'
        ? 'Units/Locations'
        : mode.charAt(0).toUpperCase() + mode.slice(1);

  return (
    <div className="bg-card border-t border-border p-2 flex justify-between items-center text-sm text-muted-foreground data-testid='status-bar'">
      <div className="flex items-center gap-4">
        <Badge variant="outline">Mode: {modeLabel}</Badge>
        <Badge variant="outline">Scale: {(scale * 100).toFixed(0)}%</Badge>
        {photoIndexMode && <Badge variant="outline">Selected: {selectedMarkers.size}</Badge>}
        {savePhotoMarkersMutation.isPending && <Badge variant="outline">Saving Markers...</Badge>}
      </div>

      <div className="flex items-center gap-4">
        {mode === 'measure' && <span>Lasso points: {currentPolygon.length}</span>}

        {mode !== 'measure' && (isHorizontalConstrained || isVerticalConstrained) && (
          <Badge variant="secondary" className="text-amber-600 dark:text-amber-400">
            Constraint: {isHorizontalConstrained ? 'Horizontal' : 'Vertical'}
          </Badge>
        )}
      </div>
    </div>
  );
};

export default StatusBar;
